import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas-pro'
import { type Prescription } from './types'

export const generatePrescriptionPDF = async (
  contentRef: React.RefObject<HTMLDivElement>,
  prescription: Prescription
): Promise<void> => {
  if (!contentRef.current) {
    console.error('Could not find element to convert to PDF')
    return
  }

  try {
    const canvas = await html2canvas(contentRef.current, {
      scale: 2, // Higher scale for better quality
      logging: false,
      useCORS: true,
      allowTaint: true
    })

    const imgData = canvas.toDataURL('image/png')
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    })

    const imgWidth = 210 // A4 width in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width

    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight)

    // Generate a filename based on patient name and date
    const filename = `Prescription_${prescription.patientName.replace(
      /\s+/g,
      '_'
    )}_${new Date().toISOString().split('T')[0]}.pdf`

    pdf.save(filename)
  } catch (error) {
    console.error('Error generating PDF:', error)
  }
}
